import { render, staticRenderFns } from "./tabsNav.vue?vue&type=template&id=17e52d04"
import script from "./tabsNav.vue?vue&type=script&lang=js"
export * from "./tabsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports